<template>
    <div class="carBox">
        <el-card class="box-card">
            <div class="mainBody">
                <div class="searchBox">
                    <div class="searchGroup">
                        <label>所在工程：</label>
                        <el-select v-model="search_Obj.f_top_pid" clearable placeholder="请选择" style="width: 200px" @keyup.enter.native="doSearch">
                            <el-option v-for="item in enuObj('project_group')" :key="'project_group'+item.key" :label="item.title" :value="item.key"> </el-option>
                        </el-select>
                    </div>
                    <div class="searchGroup">
                        <label>巡检时间：</label>
                        <el-date-picker v-model="dateRange" type="daterange" value-format="yyyy-MM-dd" unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="pickerOptions"
                            @change="dateRangeSet"
                            style="width:420px">
                        </el-date-picker>
                    </div>
                    <el-button type="primary" plain @click.native="doSearch">搜索</el-button>
                    <Btns :menu_id="menu_id" :menus="main_btns" @on_btnclk="btnClick"></Btns>
                </div>
                <div class="dataBox">
                    <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                        <el-table-column prop="top_pid" label="所在工程" sortable="custom">
                            <template slot-scope="scope">
                                <span>{{ transEnu(scope.row.top_pid, "project_group") }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="day" label="日期" sortable="custom"></el-table-column>
                        <el-table-column prop="device_count" label="需巡检设备数量" sortable="custom"></el-table-column>
                        <el-table-column prop="device_count_yes" label="实际巡检数量" sortable="custom"></el-table-column>
                        <el-table-column prop="device_count_no" label="未巡检数量" sortable="custom"></el-table-column>
                        <el-table-column label="操作" width="180" align="center">
                            <template slot-scope="scope">
                                <LabBtns :menu_id="menu_id" :row="scope.row" :index="scope.$index" :menus="lab_btns" @on_btnclk="labelClick"></LabBtns>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="pageBox">
                    <el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50]" :current-page="current" :page-size="pagesize" :total="total" @current-change="pageChange" @size-change="handleSizeChange"></el-pagination>
                </div>
                <Edit
                    width="600px"
                    :id="model_id"
                    title="设置备注"
                    :isshow="editshow"
                    @on-close="closeEditDialog"
                    @on-save-ok="saveOk">
                </Edit>
                <Info
                    width="600px"
                    :id="model_id"
                    title="查看设备巡检报告"
                    :isshow="infoshow"
                    @on-close="closeInfoDialog">
                </Info>
            </div>
        </el-card>
        <Inspection
            width="1200px"
            :report_id="model_id"
            title="设备巡检记录"
            :isshow="logshow"
            @on-close="closeInspectionDialog">
        </Inspection>
        <el-dialog title="请选择要导出的月份" :visible.sync="export_month_show" width="500px">
            <el-form ref="formValidate" label-width="120px">
                <el-form-item label="月份：" prop="day">
                    <el-date-picker v-model="month" type="month" value-format="yyyy-MM" placeholder="选择月份"></el-date-picker>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="closeExportMonth">取 消</el-button>
                <el-button type="primary" @click="doExportMonth">导 出</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import Btns from "@/components/common/btns"
import LabBtns from "@/components/common/labbtns"
import Edit from "./edit"
import Info from "./info"
import listutil from "@/libs/listutil"
import Inspection from "../deviceinspectionlog/list1"
import { exportInspectionDevice, exportMonth } from '@/api/inspection'

export default {
    name: 'deviceInspectionReportList',
    mixins: [listutil],
    components: {Edit, Info, Btns, LabBtns, Inspection},
    data() {
        return {
            m_name: '设备巡检报告',
            menu_id: 3700,
            list_url: "/api/admin/deviceinspectionreport/list",
            search_Obj: {
                f_top_pid: '',
                f_add_time_s_date: '',
                f_add_time_e_date: ''
            },
            del_Obj:{
                url:'/api/admin/deviceinspectionreport/del',
                data:{
                    ids:''
                }
            },
            enu_name: ['project_group'],
            dateRange: [],
            logshow: false,
            export_month_show: false,
            month: '',
        };
    },
    methods: {
        dateRangeSet(val){
            if(this.$isNotNull(val)){
                this.search_Obj.f_add_time_s_date = val[0]
                this.search_Obj.f_add_time_e_date = val[1]
            }else{
                this.search_Obj.f_add_time_s_date = ''
                this.search_Obj.f_add_time_e_date = ''
            }
        },
        info(index, row){
            this.model_id = row.id
            this.logshow = true
        },
        closeInspectionDialog(){
            this.logshow = false
        },
        export(){
            exportInspectionDevice(this.search_Obj.f_top_pid, this.search_Obj.f_add_time_s_date, this.search_Obj.f_add_time_e_date).then(res=>{
                if(res.code == 1){
                    window.open(res.data)
                }else{
                    this.$msg(res.msg)
                }
            })
        },
        exportMonth(){
            this.export_month_show = true
        },
        doExportMonth(){
            if (this.$isNull(this.month)) {
                this.$msg("请选择要导出的月份")
                return
            }
            this.export_month_show = false
            exportMonth(this.month).then(res=>{
                if(res.code == 1){
                    window.open(res.data)
                }else{
                    this.$msg(res.msg)
                }
            })
        },
        closeExportMonth(){
            this.export_month_show = false
        },
    }
};
</script>